module.exports = __webpack_public_path__ + "static/media/Volunteer_orange.2a85b52a.png";